// extracted by mini-css-extract-plugin
module.exports = {"img":"PreloadImage_img__3anU0","isLoaded":"PreloadImage_isLoaded__30V_B"};